import { render } from "./EditInstallation.vue?vue&type=template&id=46ec45b3"
import script from "./EditInstallation.vue?vue&type=script&lang=js"
export * from "./EditInstallation.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__